
export default class RoomFeatures {

	static getHolderSelectors = () => ['.room-features-element'];

	/** @type {HTMLElement} */
	#holderElement;

	/** @param {HTMLElement} holderElement */
	constructor(holderElement) {
		this.#holderElement = holderElement;
		let self = this;

		if ('IntersectionObserver' in window) {
			const observer = new IntersectionObserver(function (entries) {
				if (entries[0].isIntersecting) {
					self.#holderElement.classList.add('scrolled');
				}
			});
			if (document.querySelector('header')) {
				observer.observe(self.#holderElement);
			}
		}
	}

}
